import { Badge, Box, IconButton, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from '../../../../redux/store';
import Iconify from '../../../../reusable-components/iconify';
import { TabPanel } from '../../../../reusable-components/tab-panel';
import CompletedOrderInformation from './CompletedOrderInformation';
import InvoicePdfAttachment from './InvoicePdfAttachment';
import OrderInformation from './OrderInformation';

ReviewInvoice.propTypes = {
  selectedFileId: PropTypes.number,
  highlightMissingGls: PropTypes.bool,
  setOpenSidebar: PropTypes.func,
  setUnsavedData: PropTypes.func,
  unsavedData: PropTypes.object,
  vendor: PropTypes.string,
  extraControls: PropTypes.node,
  highlightItem: PropTypes.object,
  invoiceDataLoaded: PropTypes.bool,
  pdfHighlightRegion: PropTypes.object,
  addItemsToChat: PropTypes.bool,
  setAddItemsToChat: PropTypes.func,
  selectedChatItemIds: PropTypes.array,
  setSelectedChatItemIds: PropTypes.func,
};

export default function ReviewInvoice({
  selectedFileId,
  highlightMissingGls,
  setOpenSidebar,
  setUnsavedData,
  unsavedData,
  vendor,
  extraControls,
  highlightItem,
  invoiceDataLoaded,
  pdfHighlightRegion,
  addItemsToChat,
  setAddItemsToChat,
  selectedChatItemIds,
  setSelectedChatItemIds,
}) {
  const [value, setValue] = useState(0);
  const [expandBottom, setExpandBottom] = useState(false);
  const [expandCompletedOrderInformation, setExpandCompletedOrderInformation] = useState(false);
  const {
    data: { invoiceItemData },
  } = useSelector((state) => state.invoicing);
  const { invoiceItems, maximumItemDiscrepancy, invoice } = invoiceItemData || {};
  const handleTabChange = (event, newValue) => {
    if (newValue === 1 || newValue === 2) setOpenSidebar(false);
    setValue(newValue);
  };

  useEffect(() => {
    if (selectedFileId !== 0) {
      setValue(0);
    }
  }, [selectedFileId]);

  useEffect(() => {
    if (highlightMissingGls) {
      setValue(1);
      setOpenSidebar(false);
    }
  }, [highlightMissingGls]);

  useEffect(() => {
    if (highlightItem?.form === 'electronicinvoice') {
      setValue(1);
    }
  }, [highlightItem]);

  useEffect(() => {
    if (addItemsToChat) {
      setValue(1);
    }
  }, [addItemsToChat]);
  
  const countErrors = () =>
    invoiceItems?.reduce((accumulator, currentValue) => {
      const moreSentThenOrdered = currentValue.quantity > currentValue.expectedAmount;
      const overMax = Math.abs(currentValue.price - currentValue.expectedItemPrice) > maximumItemDiscrepancy;
      if(invoice?.orderId) {
        if (moreSentThenOrdered) accumulator++;
        if (overMax) accumulator++;
      }
      return accumulator;
    }, 0);
  return (
    <>
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 0,
            mt: 0,
          }}
        >
          <Tabs value={value} onChange={handleTabChange} sx={{ minHeight: 32 }}>
            <Tab label="Attachment" sx={{ minHeight: 32 }} />
            {(invoice?.sourceMethod !== 'Manual' || invoiceItems?.length > 0) && (
              <Tab
                label={
                  <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                    <Badge badgeContent={countErrors()} color="error">
                      Invoice Details
                    </Badge>
                  </Box>
                }
                sx={{ minHeight: 32 }}
              />
            )}
            {invoice?.orderId > 0 && <Tab label="Previous order" sx={{ minHeight: 32 }} />}
          </Tabs>
          <Box>{extraControls}</Box>
        </Box>
        <TabPanel value={value} index={0}>
          <InvoicePdfAttachment selectedFileId={selectedFileId} highlightRegion={pdfHighlightRegion} />
        </TabPanel>
        {(invoice?.sourceMethod !== 'Manual' || invoiceItems?.length > 0) && (
          <TabPanel value={value} index={1}>
            <OrderInformation
              highlightMissingGls={highlightMissingGls}
              highlightItem={highlightItem}
              expandBottom={expandBottom}
              unsavedData={unsavedData}
              setUnsavedData={setUnsavedData}
              invoiceDataLoaded={invoiceDataLoaded}
              addItemsToChat={addItemsToChat}
              setAddItemsToChat={setAddItemsToChat}
              selectedChatItemIds={selectedChatItemIds}
              setSelectedChatItemIds={setSelectedChatItemIds}
            />
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <IconButton onClick={() => setExpandBottom(!expandBottom)} sx={{ color: 'info.main' }}>
                <Iconify icon={`ic:twotone-expand-${!expandBottom ? 'more' : 'less'}`} width={26} height={26} />
              </IconButton>
            </Box>
          </TabPanel>
        )}
        {invoice?.orderId > 0 && (
          <TabPanel value={value} index={invoice?.sourceMethod === 'Manual' && invoiceItems?.length === 0 ? 1 : 2}>
            <CompletedOrderInformation expandBottom={expandCompletedOrderInformation} vendor={vendor} />
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <IconButton
                onClick={() => setExpandCompletedOrderInformation((expand) => !expand)}
                sx={{ color: 'info.main' }}
              >
                <Iconify
                  icon={`ic:twotone-expand-${!expandCompletedOrderInformation ? 'more' : 'less'}`}
                  width={26}
                  height={26}
                />
              </IconButton>
            </Box>
          </TabPanel>
        )}
      </Box>
    </>
  );
}

